import { PropsWithChildren, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { updateLocale } from 'utils'

export const Locale = ({ children }: PropsWithChildren) => {

    const [ searchParams ] = useSearchParams()
    const locale = searchParams.get('locale')
    useEffect(() => {
        if(locale){
            updateLocale(locale)
        }
    }, [locale])

    return <>{children}</>
    
}
